// extracted by mini-css-extract-plugin
export default {"title":"HeaderLong_title__XMT6c","tabs":"HeaderLong_tabs__wj-kA"};